import React from 'react';
import { connect } from 'react-redux';
import { sessionCheck } from 'src/actions/user';
import AccountBasics from 'src/components/settings/AccountBasics';
import AccountAdministrators from 'src/components/settings/AccountAdministrators';
import ConfigurationDefaults from 'src/components/settings/ConfigurationDefaults';
import Authentication from 'src/components/settings/Authentication';
import EmailDelivery from 'src/components/settings/EmailDelivery';
import { handleErrorWithDialog } from 'src/util/Errors';
import { TrackingAnalytics } from 'src/analytics/TrackingAnalytics';
import './Settings.css';
import { BrowserChecker } from 'src/BrowserChecker';
import { NavigationUtils } from 'src/util/NavigationUtils';
import { ScreenRecorder } from 'src/util/ScreenRecorder';

class Settings extends React.Component {

  constructor(props) {
    super(props);
    TrackingAnalytics.mixpanelTrackPageViewed();

    // Mobile blocked from Org dash
    if (BrowserChecker.isMobile()) {
      NavigationUtils.backToPopin();
    }
  }

  componentDidMount() {
    const { sessionCheck } = this.props;
    sessionCheck(true);

    // Scroll to page top on initial page load
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    const { user, userError } = this.props;
    if (!prevProps.user && !!user) {
      ScreenRecorder.record(false);
    }

    if (userError) {
      handleErrorWithDialog(userError, prevProps.userError,
        'Unable to load your Account, please try again later');
    }
  }

  setComponentRef = ($element) => {
    TrackingAnalytics.listenForActiveUser($element, 'Settings');
  };

  render() {
    const { user } = this.props;
    if (!user) {
      return (
        <div className="org-dash settings-loading container py-3" ref={this.setComponentRef}>
          <div className="content">Loading...</div>
        </div>
      );
    } else {
      return (
        <div className="org-dash container py-3" ref={this.setComponentRef}>
          <div className="content col">

            <div className="row">
              <div className="col-lg-12">
                <AccountBasics />
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <AccountAdministrators />
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <ConfigurationDefaults />
              </div>
            </div>

            <div className="row page-break-before">
              <div className="col-lg-12">
                <EmailDelivery />
              </div>
            </div>

            {/* <div className="row">
              <div className="col-lg-12">
                <Integrations />
              </div>
            </div> */}

            <div className="row">
              <div className="col-lg-12">
                <Authentication />
              </div>
            </div>

          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.user,
    userError: state.user.error
  };
};

export default connect(mapStateToProps, { sessionCheck })(Settings);
